module.exports = __webpack_public_path__ + "img/box-2-ua.89965847.png";